/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { ICON_MAP_MARKER, Symbol } from '@doveit/lego';
import React, { FunctionComponent, useCallback } from 'react';
import { URLObject } from '../../utils/links';
import * as styles from './JobOfferCard.style';

export interface JobOfferCardProps {
  title: string,
  location: string,
  urlObject?: URLObject,
  onClick?: VoidFunction,
}

const JobOfferCard: FunctionComponent<JobOfferCardProps> = ({
  title,
  location,
  urlObject,
  onClick,
}) => {
  const Tag = urlObject?.as ? 'a' : 'div';

  // Prevent default behaviour when
  // both onClick and href props are provided
  const internalOnClick = useCallback((e) => {
    e.preventDefault();

    if (onClick) {
      onClick();
    }
  }, [onClick]);

  return (
    <article
      onClick={internalOnClick}
      css={styles.base}
    >
      <Tag
        href={urlObject?.as}
      >
        <strong>{title}</strong>
      </Tag>
      <div css={styles.location}>
        <span>{location}</span>
        <Symbol
          path={ICON_MAP_MARKER}
          size={18}
        />
      </div>
    </article>
  );
};

export default JobOfferCard;
